import actions from './actions';
import getters from './getters';
import mutations from './mutations';
import * as dateutil from '@/util/date-helper';

// initial state
const state: calendar.state.CalendarState = {
    showContentMask: false,
    todayMode: null,
    isShowIgnorePanel: false,
    currentRecurringItem: null,
    currentCalendarItem : {
        parentId: '',
        attachments: [] as any,
        hasAttachments: false,
        body: '',
        location: '',
        subject: '',
        status: 'S0',
        appointmentType: 'Single',
        pidLidRecurrenceType: 1,
        ui_resourceArray: [] as Array<any>,
        resourceId: null,
        resources: [] as Array<any>,
        recurrence: {
            startDate: dateutil.uGetDateFormat('yyyy-MM-dd', new Date()),
            endDate: dateutil.uGetDateFormat('yyyy-MM-dd', dateutil.uGetDate(90)),
            ui_useRecurringButton: true,
            ui_useDefaultDate: true,
            ui_useRecurringDisplay: false,
            ui_useRecurring: false,
            ui_recurringType: 1,
            monthValue: (new Date().getMonth() + 1),
            firstDayOfWeekValue: 1,
            daysOfTheWeekArray: [] as number[],
            ui_endType: '1',
            interval: 1,
            numberOfOccurrences: 0,
        } as calendar.CalendarItemRecurrence,
        code: '',
        codeValues: [] as string[],
        importance: 'Normal',
        isCancelled: false,
        isRecurring: false,
        isAllDayEvent: false,
        isAllowUpdate: true,
        start: dateutil.uGetDateFormat('yyyy-MM-DDTH:i:00', new Date()),
        starttime: '',
        endtime: '',
        end: dateutil.uGetDateFormat('yyyy-MM-DDTH:i:00', new Date()),
        requiredAttendees: [] as any,
        optionalAttendees: [] as any,
        isReadyData: false,
        reminderMinutesBeforeStart: 15,
    },

    isLoading: false,
    currentUser: null,
    allowedResponseActions: '',
    currentError: '',
    miniCalendarMatrix: [],
    calendarSelectedEventID: '',
    calendarMonthMatrix: [],
    calendarNextMonthMatrix: [],
    calendarWeekMatrix: [],
    calendarDateMatrix: [],
    calendarMode: 'month',
    calendarEvents: [],
    calendarPrintEvents: [],
    calendarDailyEvents: [],
    calendarHideShow: true,
    searchEvents: [],
    showRecurringOption: false,
  
    backupDate: {
        date: new Date(),
        isToday: false,
        isSelected: false,
        isWorkingTime: false,
        isSun: false,
        isSat: false,
        events: [], // CalendarItem List
    },
    currentDate: {
        date: new Date(),
        isToday: false,
        isSelected: false,
        isWorkingTime: false,
        isSun: false,
        isSat: false,
        events: [], // CalendarItem List
    },
    currentCalendarDate: {
        date: new Date(),
        isToday: false,
        isSelected: false,
        isWorkingTime: false,
        isSun: false,
        isSat: false,
        events: [], // CalendarItem List
    },
    currentCalendarTime: {
        date: new Date(),
        isToday: false,
        isSelected: false,
        isWorkingTime: false,
        isSun: false,
        isSat: false,
        events: [], // CalendarItem List
    },
    monthDate: new Date(),
    folders: {
        mylist: {
            basics: [],
            items: [],
            checkedIdxArray: [],
        },
        companylist: {
            basics: [],
            items: [],
            checkedIdxArray: [],
        },
        deptlist: {
            basics: [],
            items: [],
            checkedIdxArray: [],
        },
        sharedlist: {
            basics: [],
            items: [],
            checkedIdxArray: [],
        },
        currentFolder: null,
        status: 'S0',
    },
    currentContextState: 'Closed',
    currentCalendar: null,
    newCalendar: {
        item: null,
    },
    editCalendar: {
        item: null,
    },
    toolbar: {
        search: {
            ParentFolderID: null,
            Subject: null,
            Location: null,
            OrganizerName: null,
            OrganizerAddress: null,
            RequiredAttendees: [],
            OptionalAttendees: [],
            StartDate: dateutil.uGetDateFormat('yyyy-MM-DDT00:00:00', dateutil.uGetDate(-90)),
            EndDate: dateutil.uGetDateFormat('yyyy-MM-DDT00:00:00', new Date()),
            PersonCode: null,
            EumPageNumber: 1,
            EumRowsPerPage: 200,
            
        },
        sorts: [],
        selectedFolder: null,
        folderShare: {
            FolderID: '',
            FolderName: '',
            SharedList: [],

        },
        showDetailShareOption: false,
        showDetailSearchOption: false,
    },
    recursionFlags: {
        CALENDAR_EVENT_LOAD_LIST: 0,
        CALENDAR_DAILY_EVENT_LOAD_LIST: 0,
    },
    delegateUser: '',
    loadedActions: [],
} as any;

export default {
    state,
    actions,
    getters,
    mutations,
};
